module.exports = __webpack_public_path__ + "img/compressed-1981197902164398080.e73bbb6e.png";